import { lazy } from 'react';

/** Загружает список шаблонов промокодов */
export const PromoCodeTemplatesPageAsync = lazy(() => import('./PromoCodeTemplatesPage'));
